export default __webpack_public_path__ + "static/media/wec4.263b32c6.jpg";